import * as signalR from '@microsoft/signalr';
import {Subject} from '@microsoft/signalr';
import {ObjectChangeEvent, ObjectChangeType} from '@/libs/core/realtime/object-change-event';
import SentCorrelationIds from '@/libs/core/sent-correlation-ids';

class RealtimeClient {
    created = new Subject<ObjectChangeEvent>();
    updated = new Subject<ObjectChangeEvent>();
    deleted = new Subject<ObjectChangeEvent>();

    private connection!: signalR.HubConnection;

    async init() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl((window as any).ApiService.baseUrl + "/events")
            .withAutomaticReconnect()
            .build();

        try {
            await this.connection.start();
            this.forward(ObjectChangeType.ObjectAdded, this.created);
            this.forward(ObjectChangeType.ObjectUpdated, this.updated);
            this.forward(ObjectChangeType.ObjectDeleted, this.deleted);
        } catch (error) {
            console.error(error);
        }
    }

    private forward(type: ObjectChangeType, subject: Subject<ObjectChangeEvent>) {
        this.connection.on(type, (json: string) => {
            const event: ObjectChangeEvent = JSON.parse(json);
            if (!this.isOwnRequest(event.correlationId)) {
                subject.next(event);
            }
        });
    }

    private isOwnRequest(correlationId: string): boolean {
        const index = SentCorrelationIds.indexOf(correlationId);
        if (index < 0)
            return false;

        SentCorrelationIds.splice(index, 1);
        return true;
    }
}

export default new RealtimeClient();
